import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    root: {},
    headerWrapper: {
        paddingTop: theme.spacing(3.75),
        paddingBottom: theme.spacing(3.75),
        [theme.breakpoints.down('md')]: {},
    },
    headerImage: {
        width: 100,
        height: 100,
        [theme.breakpoints.down('md')]: {
            width: 80,
            height: 80,
        },
        [theme.breakpoints.down('sm')]: {
            width: 55,
            height: 55,
        },
    },
    pageContentWrapper: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
        [theme.breakpoints.down('sm')]: {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
        },
    },
}));
